/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityMemberDTO
 */
export interface EntityMemberDTO {
    /**
     * 
     * @type {boolean}
     * @memberof EntityMemberDTO
     */
    hidden: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityMemberDTO
     */
    key: string;
}

/**
 * Check if a given object implements the EntityMemberDTO interface.
 */
export function instanceOfEntityMemberDTO(value: object): value is EntityMemberDTO {
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function EntityMemberDTOFromJSON(json: any): EntityMemberDTO {
    return EntityMemberDTOFromJSONTyped(json, false);
}

export function EntityMemberDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityMemberDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'hidden': json['hidden'],
        'key': json['key'],
    };
}

export function EntityMemberDTOToJSON(value?: EntityMemberDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hidden': value['hidden'],
        'key': value['key'],
    };
}

